<template>
    <b-overlay :show="showoverlay" rounded="sm">
    <div>
        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
        <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{warningmsg}}</b-alert>
        <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{dangermsg}}</b-alert>
        <div class="row">
            <div class="col-md-10 col-sm-12" >
                <h4 class="atlhr-dashboard-title mt-10">Employee Gratuity Fund Loan List<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Employee GF Loan List</span></h4>
            </div>
            <div class="col-md-2 col-sm-12 d-flex align-items-end justify-content-end" >
                <div class="pl-0 pr-2 company-employee-count" style="height: 31px; position: unset;"></div>
            </div>
        </div>
        <div  class="clearfix row no-gutters" v-if="employee_id > 0">            
            <gf-loan-public-info :pageurl="this.$api_url" :employee_id="employee_id" :key="c_flg"></gf-loan-public-info>
        </div>
         <div class="clearfix company-form-container" v-if="employee_id > 0">                  
            <gf-employee-loan-list :pageurl="this.$api_url" :flg="1"  :employee_id="employee_id"  ></gf-employee-loan-list>
        </div>  
    </div>
    </b-overlay>
</template>
<script>

    export default{
        mounted() {
            this.setTabIndex();
            //this.showoverlay = false;  
            setTimeout(this.showContent , 3000);    
            
        },
        props: ['pageurl' , 'readonly'],
        
        data(){            
            
            return {
                showoverlay : true,
                cu:window.location.href,
                ce : true,
                employee_id:0,
                pageUrl : this.$api_url,
                pgeUrl : this.$api_url,
                avatarsrc : null,
                company_id : 0,
                ewtabIndex : 0,
                employee_exists : 'employee-exists',
                public_info : [{name:'', email:'', jobposition:'', department:'', company:'', join_date:'', contract_expire:''}],
                
                isHovered: false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,

                c_flg: 0, // This variable is for reloading public info

            }
        },
        methods:{
            
            showContent: function()
            {
                this.showoverlay = false;
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;   
                    if(this.ce == false) this.ewtabIndex = 0;

                }.bind(this));
            }, 
            showSerch: function(){
                this.$bvModal.show('bv-modal-employeesearch');
            },
            handleHover(hovered) {
                
                this.isHovered = hovered
            },
            getEmployeeData: function(){
                if(!this.checkNet()) return false;
                
                this.c_flg += 1;
                
            },                        
            
            getAccountEmployees (value) 
            {
                this.employee_id = value.employee_id;
                if(this.employee_id > 0)
                {
                    this.getEmployeeData();
                }                   

            },
            getContractForm (value) 
            {
                this.public_info.contract_expire = value.contract_expire;
            },
            setTabIndex:function(event)
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/getid')
                    .then(function (response) {

                        if(this.ce == false)
                        {
                            this.ewtabIndex = 0;
                            return;
                        }
                        
                        this.employee_id = response.data;
                        
                            let uri = window.location.href.split('?');
                            if (uri.length == 2)
                            {
                                let vars = uri[1].split('&');
                                let getVars = {};
                                let tmp = '';
                                vars.forEach(function(v){
                                    tmp = v.split('=');
                                    if(tmp.length == 2)
                                        getVars[tmp[0]] = tmp[1];
                                });
                                //console.log(getVars['#']);
                                if(getVars['#'])
                                    this.ewtabIndex = parseInt(getVars['#']);
                                
                            }                       
                                            

                    }.bind(this));                

            },
        },
        created: function(){
            //
            this.getAcl();
            //this.getEmployeeData();
            //this.setTabIndex();
        }

    }

</script>